import { useEffect, useState } from "react";
import { CarFront } from "lucide-react";
import { cn } from "../lib/utils";
import { useLanguage } from "../contexts/LanguageContext";

export const CarImage = ({
  src,
  alt,
  className,
  imgClassName,
  iconClassName,
  ...props
}) => {
  const { t } = useLanguage();
  const [hasError, setHasError] = useState(!src);

  useEffect(() => {
    setHasError(!src);
  }, [src]);

  if (!src || hasError) {
    return (
      <div
        className={cn(
          "flex h-full w-full items-center justify-center bg-[radial-gradient(circle_at_top_left,_rgba(212,175,55,0.24),_transparent_42%),linear-gradient(135deg,_#111111,_#1f1f1f_55%,_#0d0d0d)]",
          className,
        )}
      >
        <div className="flex flex-col items-center gap-3 text-white/75">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm">
            <CarFront className={cn("h-8 w-8 text-[#D4AF37]", iconClassName)} />
          </div>
          <img
            src="/velaris-logo-light.png"
            alt={t("accessibility.logoAlt", "Velaris Royal Car Rental")}
            className="h-5 w-auto object-contain opacity-75"
          />
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={cn("h-full w-full object-cover", className, imgClassName)}
      loading="lazy"
      onError={() => setHasError(true)}
      {...props}
    />
  );
};

export default CarImage;
